import { QueryMeta, useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

type Payload = Parameters<typeof API.setsSadl.getSet>[0];

export const useSadlSet = (params: Payload, meta?: QueryMeta) => {
  const query = useQuery({
    queryKey: [QueryKeys.LastDmInspectionParams, params],
    queryFn: async () => API.setsSadl.getSet(params),
    enabled: Boolean(params.serial) && Boolean(params.supplier_tenant_name),
    meta,
  });

  return {
    ...query,
    isLoading: query.isFetching, // the query is only enabled when params are available is defined so technically it's not loading
  };
};
